<div class="file-preview-box">
  <button *ngIf="download" mat-icon-button (click)="onDownloadFile()" class="prev-fil-download">
    <mat-icon svgIcon="cloud-download"></mat-icon>
  </button>
  <h4>{{ file.fileName }}</h4>
  <span class="file-size-type">Format {{ formatExt(file.fileName | fileExt | uppercase) }}</span>
  <span class="file-size-type ml-25">Size {{ file.fileSize | byteSize }}</span>
  <button *ngIf="edit" mat-icon-button (click)="delete.emit(file)" class="prev-fil-del">
    Delete
  </button>
</div>
